export const createInitialImageProcessingState = () => ({
    currentOrderId: null,
    isArchived: false,
    numberOfImages: null,
    comments: null,
    edited: {
        extraSelected: 0,
        list: []
    },
    unedited: {
        list: []
    },
    modal: {
        images: []
    },
    deliveryStatus: {
        isDirectOrder: false,
        delivered: false,
        deliveryMessage: null,
        deliveryDate: null,
        deliverOnlyToMail: null
    },
    photoStatus: {
        currentStatus: 0,
        isCorrectNumberOfImages: false,
        photosInRows: [],
        normalImagesAvailable: false,
        canReapprove: false
    },
    imageGalleryReference: '',
    contentProvider: null,
    orderCollectionId: 0,
    orderApiUrl: '',
    contentProviderValue: 0,
    imageOverrides: []
});

export default {
    viewOrder: {
        common: {
            orderNumber: ''
        },
        contactAddress: {},
        film: {},
        text: {},
        imageProcessing: createInitialImageProcessingState(),
        delivery: {
            imageThumbnails: []
        }
    }
};
